import { jsxs as u, jsx as l } from "react/jsx-runtime";
import b from "react";
import { c as i } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const f = {
  xs: "h-6 w-6 text-xs",
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
  xl: "h-14 w-14 text-lg",
  "2xl": "h-16 w-16 text-xl"
}, y = {
  online: "bg-green-500",
  offline: "bg-gray-400",
  away: "bg-yellow-500",
  busy: "bg-red-500"
}, N = {
  xs: "h-1.5 w-1.5",
  sm: "h-2 w-2",
  md: "h-2.5 w-2.5",
  lg: "h-3 w-3",
  xl: "h-3.5 w-3.5",
  "2xl": "h-4 w-4"
};
function S(r) {
  const t = r.trim().split(/\s+/);
  return t.length === 1 ? t[0].slice(0, 2).toUpperCase() : (t[0][0] + t[t.length - 1][0]).toUpperCase();
}
function A(r) {
  const t = [
    "bg-red-500",
    "bg-orange-500",
    "bg-amber-500",
    "bg-yellow-500",
    "bg-lime-500",
    "bg-green-500",
    "bg-emerald-500",
    "bg-teal-500",
    "bg-cyan-500",
    "bg-sky-500",
    "bg-blue-500",
    "bg-indigo-500",
    "bg-violet-500",
    "bg-purple-500",
    "bg-fuchsia-500",
    "bg-pink-500",
    "bg-rose-500"
  ];
  let e = 0;
  for (let s = 0; s < r.length; s++)
    e = r.charCodeAt(s) + ((e << 5) - e);
  return t[Math.abs(e) % t.length];
}
const E = ({
  src: r,
  alt: t,
  fallback: e,
  size: s = "md",
  shape: g = "circle",
  status: o,
  onClick: n,
  className: a,
  testId: c
}) => {
  const [d, h] = b.useState(!1), m = r && !d, x = e ? S(e) : "?", p = e ? A(e) : "bg-muted", w = () => {
    h(!0);
  };
  return b.useEffect(() => {
    h(!1);
  }, [r]), /* @__PURE__ */ u(
    "div",
    {
      className: i("relative inline-flex shrink-0", a),
      "data-testid": c,
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            className: i(
              "inline-flex items-center justify-center overflow-hidden",
              f[s],
              g === "circle" ? "rounded-full" : "rounded-[var(--ds-radius-md)]",
              !m && p,
              !m && "text-white font-medium",
              n && "cursor-pointer hover:opacity-80 transition-opacity"
            ),
            onClick: n,
            role: n ? "button" : void 0,
            tabIndex: n ? 0 : void 0,
            onKeyDown: n ? (v) => v.key === "Enter" && n() : void 0,
            children: m ? /* @__PURE__ */ l(
              "img",
              {
                src: r,
                alt: t || e || "Avatar",
                className: "h-full w-full object-cover",
                onError: w
              }
            ) : /* @__PURE__ */ l("span", { "aria-label": e, children: x })
          }
        ),
        o && /* @__PURE__ */ l(
          "span",
          {
            className: i(
              "absolute bottom-0 right-0 block rounded-full ring-2 ring-background",
              y[o],
              N[s]
            ),
            "aria-label": `Status: ${o}`
          }
        )
      ]
    }
  );
}, j = {
  tight: "-space-x-3",
  normal: "-space-x-2",
  loose: "-space-x-1"
}, G = ({
  avatars: r,
  max: t = 4,
  size: e = "md",
  spacing: s = "normal",
  className: g,
  testId: o
}) => {
  const n = r.slice(0, t), a = r.length - t;
  return /* @__PURE__ */ u(
    "div",
    {
      className: i("flex items-center", j[s], g),
      "data-testid": o,
      children: [
        n.map((c, d) => /* @__PURE__ */ l(
          E,
          {
            ...c,
            size: e,
            className: "ring-2 ring-background"
          },
          d
        )),
        a > 0 && /* @__PURE__ */ u(
          "div",
          {
            className: i(
              "inline-flex items-center justify-center rounded-full bg-muted text-muted-foreground font-medium ring-2 ring-background",
              f[e]
            ),
            children: [
              "+",
              a
            ]
          }
        )
      ]
    }
  );
};
export {
  E as A,
  G as a
};
